import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Restaurants.css";
import Menu from "./Menu";
import {baseURL} from "./api";

// 💡 Receive priceType from props
const Restaurants = ({ priceType }) => {
  const [restaurants, setRestaurants] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const vendorId = localStorage.getItem("vendorId")?.trim();
        const response = await axios.get(`${baseURL}/getRestaurant`);
        let allRestaurants = response.data;

        // Filter restaurants based on priceType
        // Filter restaurants based on priceType
// Filter restaurants based on priceType
let filteredRestaurants = allRestaurants.filter((restaurant) => {
  const isVendorRestaurant = restaurant.vendorId?.trim() === vendorId;
  const isDefaultRestaurant = restaurant.default?.toString().toLowerCase() === "true";

  // For all priceTypes including "purchase", include vendor and default=true restaurants
  return isVendorRestaurant || isDefaultRestaurant;
});







        const updatedRestaurants = await Promise.all(
          filteredRestaurants.map(async (restaurant) => {
            if (!restaurant.price) {
              try {
                const menuResponse = await axios.get(
                  `${baseURL}/getMenuItems?restaurantId=${restaurant._id}`
                );
                const menuItems = menuResponse.data;
                const minPrice = Math.min(...menuItems.map((item) => item.price || Infinity));
                return { ...restaurant, price: minPrice !== Infinity ? minPrice : undefined };
              } catch (menuError) {
                console.error(`Error fetching menu for ${restaurant.name}:`, menuError);
                return restaurant;
              }
            }
            return restaurant;
          })
        );

        setRestaurants(updatedRestaurants);
      } catch (error) {
        console.error("Error fetching restaurant data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRestaurants();
  }, [priceType]); // Adding priceType as dependency

  const handleRestaurantClick = (restaurant) => {
    if (restaurant.status === "Closed") return;

    console.log("Selected Restaurant:", restaurant);
    localStorage.setItem("restaurantId", restaurant._id);
    setSelectedRestaurant(restaurant);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return selectedRestaurant ? (
    selectedRestaurant.status === "Closed" ? (
      <div className="closed-message">
        <h3>The restaurant is currently closed</h3>
      </div>
    ) : (
      <Menu
        restaurant={selectedRestaurant}
        menuItems={selectedRestaurant.menuItems || []}
        priceType={priceType} // ✅ Passed down correctly
      />
    )
  ) : (
    <section className="restaurants my-8">
      {/* <div className="Reshead">
        <h2 className="title">Brands</h2>
      </div> */}
      <div className="restaurants-grid">
        {restaurants.map((restaurant, index) => (
          <div
            key={index}
            className={`restaurant-card ${restaurant.status === "Closed" ? "closed" : ""}`}
            onClick={() => handleRestaurantClick(restaurant)}
          >
            <img
              src={`${baseURL}${restaurant.imgPath}`}
              alt={`${restaurant.name} logo`}
              className="restaurant-img"
              style={{ width: "100px", height: "100px", objectFit: "cover" }}
            />
            <div className="restaurant-info">
              <h3 className="restaurant-name">{restaurant.name}</h3>
              <div className="details">
                <span>
                  <i className="fas fa-star"></i> 5 (2345)
                </span>
                <span>
                  <i className="fas fa-utensils"></i> {restaurant.type}
                </span>
              </div>
              <div className="tags">
                <span className={`status-tag ${restaurant.status === "Open" ? "open" : "closed"}`}>
                  {restaurant.status}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Restaurants;
